<!-- 由 suu 创建于 2021-12-27 星期一 -->
<template>
  <div class="sel-ranking">
    <div class="sr-col sr-title">
      <div class="col-rank">排名</div>
      <div class="col-name">营养师</div>
      <div class="col-cur">爱意值</div>
      <div class="col-btn">打call</div>
    </div>
    <div class="sr-col" v-for="(item, index) in list" :key="index">
      <div class="col-rank">
        <img
          :src="
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/syr-ranking-' +
            (index + 1)
          "
          v-if="index < 3"
          alt=""
        />
        <span v-else>{{ formatNum(index + 1) }}</span>
      </div>
      <div class="col-name">
        <img :src="item.c_img" alt="" />{{ item.c_name }}
      </div>
      <div class="col-cur col-cur-c">{{ item.vote_num }}</div>
      <div class="col-btn col-btn-c user-btn" @click="handelCall(item)">
        打call
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sel-ranking',

  components: {},

  props: {
    list: {}
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 打call
    handelCall(item) {
      this.$emit('call', item)
    },
    // 数字补0
    formatNum(num) {
      return ('00' + num).slice(String(num).length)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.sel-ranking {
  width: 335px;
  background: #fff9f8;
  border-radius: 20px;
  border: 1px solid #fbe1db;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  border-radius: 20px;
  padding-bottom: 10px;
  overflow: hidden;
  .sr-col {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-family: DINPro-Medium, DINPro;
    font-weight: 500;
    color: #000000;
    padding: 10px 16px;
    .col-rank {
      width: 40px;
      text-align: center;
      img {
        width: 100%;
        box-sizing: border-box;
      }
    }
    .col-name {
      width: 120px;
      display: flex;
      align-items: center;
      font-size: 14px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        margin-right: 8px;
      }
    }
    .col-cur {
      width: 60px;
      text-align: center;
    }
    .col-cur-c {
      font-size: 18px;
      font-family: DINPro-Medium, DINPro;
      font-weight: 500;
      color: #ff7070;
    }
    .col-btn {
      width: 58px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }
    .col-btn-c {
      width: 58px;
      height: 26px;
      background: linear-gradient(207deg, #f28a6c 0%, #ed629b 100%);
      border-radius: 13px;
      color: #fff;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
  }
  .sr-title {
    height: 44px;
    background: rgba(255, 249, 232, 0.6);
    font-size: 14px;
    color: #7e4620;
    margin-bottom: 5px;
    .col-name {
      justify-content: center;
    }
  }
}
</style>
